import React, { useEffect, useRef, useState } from "react";
import Header from "../Components/Header";
import Design from "../Products/Design";
import MoreInteresting from "../Products/MoreInteresting";
import Footer from "../Components/Footer";
import MenFilter from "../MenHeadrer/MenFilter";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";

import { useDispatch, useSelector } from "react-redux";
import { get_glbFile,getAllTeamProducts,getAllTeamProductsFilters,getAllTeamProductsList,getAllTeamProductsListFiltered,productApi } from "../../Services/Operations/ProductAPI";
import { toast } from "react-toastify";
import { FaRegHeart } from "react-icons/fa6";
import { FaHeart, FaTimes } from "react-icons/fa";
import { addFavorite, removeFavorite } from "../../Redux/Cart_System";
import { useParams } from "react-router-dom";
import { color } from "framer-motion";

const SkeletonLoader1 = () => {
  return (
    <div className="skeleton-container">
      <div className="page-layout-wrapper" style={{ marginTop: "78px" }}>
        <aside className="sidebar1">
          <div className="skeleton-filter">
            {[...Array(5)].map((_, i) => (
              <div key={i} className="skeleton-filter-item">
                <div className="skeleton-text medium"></div>
                <div className="skeleton-text medium"></div>
              </div>

            ))}
          </div>
        </aside>
        {/* <section
          className="main-content"
          style={{  height: "90vh" }}
        >
          <div className="product-listing">
            <div className="product-grid">
              {[...Array(8)].map((_, i) => (
                <div key={i} className="skeleton-product-card">
                  <div className="skeleton-image"></div>
                  <div className="skeleton-text short"></div>
                  <div className="skeleton-text medium"></div>
                  <div className="skeleton-text long"></div>
                </div>
              ))}
            </div>
          </div>
        </section> */}
      </div>
      <style jsx>{`
        .skeleton-container {
          width: 100%;
          padding: 20px;
        }

        .skeleton-filter {
          padding: 15px;
        }

        .skeleton-filter-item {
          height: 90px;
          background: #e0e0e0;
          margin-bottom: 10px;
          border-radius: 4px;
          animation: pulse 1.5s infinite ease-in-out;
        }

      

        .skeleton-image {
          width: 100%;
          height: 200px;
          background: #e0e0e0;
          margin-bottom: 10px;
          border-radius: 4px;
          animation: pulse 1.5s infinite ease-in-out;
        }

        .skeleton-text {
          height: 12px;
          background: #e0e0e0;
          margin-bottom: 8px;
          border-radius: 4px;
          animation: pulse 1.5s infinite ease-in-out;
        }

        .skeleton-text.short {
          width: 60%;
        }

        .skeleton-text.medium {
          width: 80%;
        }

        .skeleton-text.long {
          width: 90%;
        }

        @keyframes pulse {
          0% {
            opacity: 0.6;
          }
          50% {
            opacity: 1;
          }
          100% {
            opacity: 0.6;
          }
        }

        .product-grid {
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
          gap: 20px;
        }
      `}</style>
    </div>
  );
};

const SkeletonLoader2= () => {
  return (
    <div className="skeleton-container">
      <div className="page-layout-wrapper" style={{ marginTop: "78px" }}>
        {/* <aside className="sidebar1">
          <div className="skeleton-filter">
            {[...Array(5)].map((_, i) => (
              <div key={i} className="skeleton-filter-item"></div>
            ))}
          </div>
        </aside> */}
        <section
          className="main-content"
          style={{  height: "110vh" }}
        >
          <div className="product-listing">
            <div className="product-grid">
              {[...Array(8)].map((_, i) => (
                <div key={i} className="skeleton-product-card">
                  <div className="skeleton-image"></div>
                  <div className="skeleton-text short"></div>
                  <div className="skeleton-text medium"></div>
                  <div className="skeleton-text long"></div>
                </div>
              ))}
            </div>
          </div>
        </section>
      </div>
      <style jsx>{`
        .skeleton-container {
          width: 100%;
          padding: 20px;
        }

        .skeleton-filter {
          padding: 15px;
        }

        .skeleton-filter-item {
          height: 30px;
          background: #e0e0e0;
          margin-bottom: 10px;
          border-radius: 4px;
          animation: pulse 1.5s infinite ease-in-out;
        }

        .skeleton-product-card {
          margin-bottom: 20px;
          padding: 10px;
        }

        .skeleton-image {
          width: 100%;
          height: 200px;
          background: #e0e0e0;
          margin-bottom: 10px;
          border-radius: 4px;
          animation: pulse 1.5s infinite ease-in-out;
        }

        .skeleton-text {
          height: 12px;
          background: #e0e0e0;
          margin-bottom: 8px;
          border-radius: 4px;
          animation: pulse 1.5s infinite ease-in-out;
        }

        .skeleton-text.short {
          width: 60%;
        }

        .skeleton-text.medium {
          width: 80%;
        }

        .skeleton-text.long {
          width: 90%;
        }

        @keyframes pulse {
          0% {
            opacity: 0.6;
          }
          50% {
            opacity: 1;
          }
          100% {
            opacity: 0.6;
          }
        }

        .product-grid {
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
          gap: 20px;
        }
      `}</style>
    </div>
  );
};

function TeamOrder() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const[filterModal,setFilterModal]=useState(false)
  const [isLoading, setIsLoading] = useState(false);
  const[productLoading,setProductLoading]=useState(false)
  const[filterLoading,setFilterLoading]=useState(false)
  const [particularProduct, setParticularProduct] = useState({});
  const[teamProduct,setTeamProduct]=useState([])
  const[pagination,setPagination]=useState([1,2,3,4,5])
  const [currentPage,setCurrentPage]=useState(1)
  const { tokenDetails } = useSelector((state) => state.user);
  const location = useLocation();

  
  const[categories,setCategories]=useState(null)
  const[colors,setColors]=useState(null)
  const[menus,setMenus]=useState(null)

  const[filterMenu,setFilterMenu]=useState(true)
  const[filterCategory,setFilterCategory]=useState(true)
  const[filterColor,setFilterColor]=useState(true)
  const[isFiltered,setFiltered]=useState(false)
  const[filterLoad,setFilterLoad]=useState(false)

  const [productData1, setProductData] = useState([]);
    const [categoryImage, setCategoryImage] = useState();
  const { configUrl } = useSelector((state) => state.cart);
  const favorites = useSelector((state) => state.cart.favorites);

  const[currentMenu,setCurrentMenu]=useState(null)
  const[currentCategory,setCurrentCategory]=useState(null)
  const[currentColor,setCurrentColor]=useState(null)

  const boxRef=useRef(null)

  // console.log("category : ", category);
  // console.log("subcategory : ", subcategory);

  // useEffect(() => {
  //   if (category && subcategory) {
  //     const fetchProducts = async () => {
  //       try {
  //         setIsLoading(true);
  //         const response = await productApi(category, subcategory);
  //         console.log("productApi : ", response);
  //         if (response.success) {
  //           setCategoryImage(response.category_image);
  //           setProductData(response.data);
  //         } else {
  //           setProductData([])
  //         }
  //       } catch (error) {
  //         console.error("API Error:", error);
  //       } finally {
  //         setIsLoading(false);
  //       }
  //     };
  //     fetchProducts();
  //   }
  // }, [category, subcategory]);

  const handleFavorite = (product) => {
    const isFavorite = favorites.some((item) => item.id === product.id);
    if (!tokenDetails) {
      toast.error("Please login or Signup");
      return;
    }

    const favoriteProduct = {
      id: product.id,
      menu_id: product.menu_id,
      category_id: product.category_id,
      subcategory_id: product.subcategory_id,
      name: product.name,
      slug: product.slug,
      image: product.image,
      menu_name: product.menu_name,
      menu_slug: product.menu_slug,
      category_name: product.category_name,
      category_slug: product.category_slug,
      subcategory_name: product.subcategory_name,
      subcategory_slug: product.subcategory_slug,
      size: product.size.find((size) => size.size_id),
    };

    console.log("favoriteProduct : ", favoriteProduct);

    if (isFavorite) {
      dispatch(removeFavorite(product.id));
    } else {
      dispatch(addFavorite(favoriteProduct));
    }
  };
  console.log("configUrl : ", configUrl);

  // console.log("Product Data:", productData1);
  // console.log("Category Name:", categoryName);


  const handleGetTeamProducts=async(page)=>{

 setProductLoading(true)
 setCurrentPage(page)
    try {
      const response1=await getAllTeamProductsList({limit:12,page:page})
        
        console.log('team products',response1);
        if(response1.status===200){

        
        setTeamProduct(response1.data.data)
        setFiltered(false)
      }
    } catch (error) {
      console.log(error);
      
    }finally{
      setProductLoading(false)
    }
  }

   const handleGetTeamProductsFilters=async()=>{
      try {setFilterLoading(true)
        const response=await getAllTeamProductsFilters()
      
        console.log('team products  filters',response);
        if(response.status===200){
          setCategories(response.data.filters.categories)
          setColors(response.data.filters.colors)
          setMenus(response.data.filters.menus)
        }
       
        
        
      } catch (error) {
        console.log(error);
        
      }finally{
        setFilterLoading(false)
      }
    }

 

  useEffect(() => {
    handleGetTeamProducts(1)
     handleGetTeamProductsFilters()
  }, [])
  
 
    const clickProductDetailsHandler = async (name) => { 
   navigate(`/detailsPage/${name}/true`);
      
  };

  // if (isLoading) {
  //   return <SkeletonLoader />;
  // }

  const handleButtonClick = async (e) => {
    e.preventDefault();
    
    
    // if (!tokenDetails) {
    //   toast.error("Please login or Signup");
    //   return;
    // }
    // try {
    //   const formData = new FormData();
     
    //   formData.append("subcategoryId","women-cricket-jersey");

    //   const result = await get_glbFile(formData);
    //   console.log("GLB Data:", result);

    //   if (result.success && result.data) {
    //     navigate("/3d-product", {
    //       state: {
    //         menuSlug: category,
    //         subcategorySlug: subcategory,
    //         glbFile: result.data,
    //       },
    //     });
    //   } else {
    //     toast.error("No 3D model available. Please try another product.");
    //   }
    // } catch (error) {
    //   console.error("Error:", error);
    //   toast.error("Something went wrong. Please try again later.");
    // }
  };

const handlefilterProducts = async () => {
  try {
    setFilterLoad(true)

    const response = await getAllTeamProductsListFiltered({
      menuId: currentMenu,
      categoryId: currentCategory,
      colorId: currentColor
    })

    console.log('team products after filters', response)

    if (response.status === 200) {
      setTeamProduct(response.data.data)
      setFiltered(true)
    }
  } catch (error) {
    console.log(error)
  } finally {
    setFilterLoad(false)
    setFilterModal(false)
  }
}



  useEffect(() => {
    const handleOutsiedClick=(event)=>{
      if(boxRef.current &&!boxRef.current.contains(event.target)){
        setFilterModal(false)
      }

    }
    document.addEventListener('mousedown',handleOutsiedClick)

    return ()=>{
      document.removeEventListener('mousedown',handleOutsiedClick)
    }
    
  }, [])
  




  return (
    <div>
      <body className="body-container default is-ctl-shield-listing-with-seo-box is-ctl-product_list is-ctl- is-act-">
        
      

        <main className="content-main" style={{ backgroundColor: "white",marginTop:"100px" }}>
          <div className="flashbags"></div>
          <div className="container-main">
            <div className="page-layout">
              <div
                className="page-layout-wrapper"
               
              >

                {window.innerWidth<567?

                // for mobile view
                <div style={{width:"70vw",backgroundColor:"white",padding:"5px"}}>{
                  filterLoading ||!categories||!menus||!colors?
                  <SkeletonLoader1 />
                  :
                  <aside className="sidebar1">
                 {/* <MenFilter
  menu={menu}
  categoryName={categoryName}
  setProductData={setProductData}
  productData={productData1}  // Add this line
/> */}

                  { filterModal ?
                    <div ref={boxRef}
                    style={{padding:"20px",display:"flex",flexDirection:"column",height:"100vh",overflowY:"auto",
                    gap:"20px",position:"fixed",zIndex:10000,backgroundColor:"white",width:"70vw",top:0,left:0}}>
                   <p style={{display:"flex",alignItems:"center",justifyContent:"space-between",fontSize:"18px",fontWeight:700,borderBottom:"1px solid black"}}>
                    <span>FILTER</span>
                    <span onClick={()=>setFilterModal(false)}> <FaTimes /></span></p>
                    
                    <div>
                      <p style={{fontSize:"15px",fontWeight:"bold",display:"flex",alignItems:"center",justifyContent:"space-between"}}>
                        <span>MENU</span>
                        <span onClick={()=>setFilterMenu(!filterMenu)} style={{cursor:"pointer"}}>
                          <img src={filterMenu?"/asset/img/up-arrow.png":"/asset/img/arrow-down.png"}
                          style={{width:"15px"}}/>
                          </span>
                        </p>

                     {filterMenu? <div style={{display:"flex"}}>{

                      menus?.map(menu=>(
                        <div onClick={()=>{currentMenu===menu.id?setCurrentMenu(null):setCurrentMenu(menu.id)}}
                        style={{padding:"5px",cursor:"pointer",fontSize:"9px",borderRadius:"5px",margin:"3px",border:"1px solid black",backgroundColor:currentMenu===menu.id?"black":"white",color:currentMenu===menu.id?"white":"black",}}>
                          {menu.name}
                        </div>
                      ))
                }</div>
                :""}
                </div>
                    <div>
                      <p style={{fontSize:"15px",fontWeight:"bold",display:"flex",alignItems:"center",justifyContent:"space-between"}}>
                        <span>CATEGORIES</span>
                         <span onClick={()=>setFilterCategory(!filterCategory)} style={{cursor:"pointer"}}>
                          <img src={filterCategory?"/asset/img/up-arrow.png":"/asset/img/arrow-down.png"}
                          style={{width:"15px"}}/>
                          </span>
                        </p>

                      {filterCategory?<div style={{display:"flex",flexWrap:"wrap"}}>
                      {
                        categories?.map(cat=>(
                          <div onClick={()=>{currentCategory===cat.id?setCurrentCategory(null):setCurrentCategory(cat.id)}}
                          style={{padding:"5px",fontSize:"9px",borderRadius:"5px",margin:"3px",border:"1px solid black",backgroundColor:currentCategory===cat.id?"black":"white",color:currentCategory===cat.id?"white":"black",}}>
                            {cat.name}
                          </div>
                        ))
                      }</div>
                      :""}
                    </div>

                    <div>
                      <p style={{fontSize:"15px",fontWeight:"bold",display:"flex",alignItems:"center",justifyContent:"space-between"}}>
                        <span>COLORS</span>
                         <span onClick={()=>setFilterColor(!filterColor)} style={{cursor:"pointer"}}>
                          <img src={filterColor?"/asset/img/up-arrow.png":"/asset/img/arrow-down.png"}
                          style={{width:"15px"}}/>
                          </span>
                        </p>

                      {filterColor?<div style={{display:"flex",flexWrap:"wrap"}}>
                      {
                      colors?.map(color=>(
                        <div  onClick={()=>{currentColor===color.id?setCurrentColor(null):setCurrentColor(color.id)}}
                        style={{padding:"5px",width:"30px",height:"30px",fontSize:"15px",borderRadius:"50%",margin:"8px",backgroundColor:color.code,border:currentColor===color.id?"2.5px solid black":" 0.5px solid gray",}}>
                          
                        </div>
                      ))
                      }</div>
                      
                      :""}
                      </div>

                      <div onClick={handlefilterProducts}
                      style={{padding:"20px", borderRadius:"10px",backgroundColor:"black",color:"white"
                      }}>{
                        filterLoad?"Applying Filters...":"Apply Filters"
                      }
                     
                      </div>
                  </div>
                  :""
                  }
                </aside>
                }</div>

                :
                  // for web view
                  <div style={{width:"25%"}}>{
                  filterLoading ||!categories||!menus||!colors?
                  <SkeletonLoader1 />
                  :
                  <aside className="sidebar1">
                 {/* <MenFilter
  menu={menu}
  categoryName={categoryName}
  setProductData={setProductData}
  productData={productData1}  // Add this line
/> */}

                  <div style={{padding:"20px",display:"flex",flexDirection:"column",gap:"20px"}}>
                    <p style={{fontSize:"20px",fontWeight:"bold"}}>FILTERS</p>
                    <div>
                      <p style={{fontSize:"15px",fontWeight:"bold",display:"flex",alignItems:"center",justifyContent:"space-between"}}>
                        <span>MENU</span>
                        <span onClick={()=>setFilterMenu(!filterMenu)} style={{cursor:"pointer"}}>
                          <img src={filterMenu?"/asset/img/up-arrow.png":"/asset/img/arrow-down.png"}
                          style={{width:"15px"}}/>
                          </span>
                        </p>

                     {filterMenu? <div style={{display:"flex"}}>{

                      menus?.map(menu=>(
                        <div onClick={()=>{currentMenu===menu.id?setCurrentMenu(null):setCurrentMenu(menu.id)}}
                        style={{padding:"5px",cursor:"pointer",fontSize:"12px",borderRadius:"5px",margin:"3px",border:"1px solid black",backgroundColor:currentMenu===menu.id?"black":"white",color:currentMenu===menu.id?"white":"black",}}>
                          {menu.name}
                        </div>
                      ))
                }</div>
                :""}
                </div>
                    <div>
                      <p style={{fontSize:"15px",fontWeight:"bold",display:"flex",alignItems:"center",justifyContent:"space-between"}}>
                        <span>CATEGORIES</span>
                         <span onClick={()=>setFilterCategory(!filterCategory)} style={{cursor:"pointer"}}>
                          <img src={filterCategory?"/asset/img/up-arrow.png":"/asset/img/arrow-down.png"}
                          style={{width:"15px"}}/>
                          </span>
                        </p>

                      {filterCategory?<div style={{display:"flex",flexWrap:"wrap"}}>
                      {
                        categories?.map(cat=>(
                          <div onClick={()=>{currentCategory===cat.id?setCurrentCategory(null):setCurrentCategory(cat.id)}}
                          style={{padding:"5px",cursor:"pointer",fontSize:"12px",borderRadius:"5px",margin:"3px",border:"1px solid black",backgroundColor:currentCategory===cat.id?"black":"white",color:currentCategory===cat.id?"white":"black",}}>
                            {cat.name}
                          </div>
                        ))
                      }</div>
                      :""}
                    </div>

                    <div>
                      <p style={{fontSize:"15px",fontWeight:"bold",display:"flex",alignItems:"center",justifyContent:"space-between"}}>
                        <span>COLORS</span>
                         <span onClick={()=>setFilterColor(!filterColor)} style={{cursor:"pointer"}}>
                          <img src={filterColor?"/asset/img/up-arrow.png":"/asset/img/arrow-down.png"}
                          style={{width:"15px"}}/>
                          </span>
                        </p>

                      {filterColor?<div style={{display:"flex",flexWrap:"wrap"}}>
                      {
                      colors?.map(color=>(
                        <div  onClick={()=>{currentColor===color.id?setCurrentColor(null):setCurrentColor(color.id)}}
                        style={{padding:"5px",width:"30px",height:"30px",fontSize:"15px",borderRadius:"50%",margin:"8px",backgroundColor:color.code,border:currentColor===color.id?"2.5px solid black":" 0.5px solid gray",}}>
                          
                        </div>
                      ))
                      }</div>
                      
                      :""}
                      </div>

                      <div onClick={handlefilterProducts}
                      style={{padding:"20px", borderRadius:"10px",backgroundColor:"black",color:"white"
                      }}>{
                        filterLoad?"Applying Filters...":"Apply Filters"
                      }
                     
                      </div>
                  </div>
                </aside>
                }</div>}
                
                {/* height:"90vh" */}


              
                
              
            
            
              <div style={{width:window.innerWidth>567?"70%":"100%"}}>  {
                  productLoading?
                  <SkeletonLoader2/>:
                  <section
                  className="main-content"
                  style={{ backgroundColor: "white" }}
                >
                  <div className="product-listing">
                    <div style={{display:"flex",position:"fixed", justifyContent:"end",
                      paddingBottom:"10px",marginLeft:"10px",marginRight:"10px",bottom:"15px",zIndex:999,width:"fit-content",right:"10px"}}>
                     
                    {
                      window.innerWidth<=567?
                      <div onClick={()=>setFilterModal(!filterModal)}
                      style={{backgroundColor:"white",color:"black",padding:"5px", margin:"5px",fontSize:"15px",border:"none",
                        borderRadius:"8px",boxShadow:"0 0 10px 2px gray",cursor:"pointer",transform:'translateY(9)',
                        transition:"all 0.1s ease-in-out",width:"fit-content",display:"flex",alignItems:"center",justifyContent:"center"
                      }}>
                        <img src="/asset/filter.png" style={{width:"16px"}}/>

                       <span style={{fontWeight:"bold"}}> Filter</span>
                      </div>
                      :""
                    }</div>

                   {window.innerWidth<=567?
                   // mobile view
                    <div className="product-grid" style={{width:"100vw"}}>
                      {teamProduct && teamProduct.length > 0 ? (
                        teamProduct?.map((product) => {
                          const isFavorite = favorites.some(
                            (item) => item.id === product.id
                          );
                          const discount = product?.size[0]?.discount_percent;
                          console.log("discount : ", discount);
                          return (
                            <div
                              key={product?.id}
                              className="product-card"
                              style={{ position: "relative",minWidth:"44vw",height:"fit-content",maxWidth:"45vw" }}
                            >
                              <div className="product-box" style={{display:"flex", flexDirection:"column", height:"100%",justifyContent:"space-between"}}>
                                {discount > 0 && (
                                  <div
                                    className="discount-badge pulse-animation"
                                
                                  >
                                    <span style={{ fontSize: "9px" }}>
                                      {discount}% OFF
                                    </span>
                                  </div>
                                )}
                                <span
                                  onClick={() => handleFavorite(product)}
                                  style={{
                                    padding: "5px 10px",
                                    position: "absolute",
                                    top: "10px",
                                    right: "10px",
                                    borderRadius: "20px",
                                    fontSize: "0.9rem",
                                    zIndex: "2",

                                    fontSize: "17px",
                                  }}
                                >
                                  {isFavorite ? (
                                    <FaHeart color="red" />
                                  ) : (
                                    <FaRegHeart color="grey" />
                                  )}
                                </span>
                                <div
                                  className="product-image-wrapper"
                                  style={{minHeight:"70%",height:"140px",width:"40vw"}}
                                  onClick={(event) => {
                                    event.preventDefault();
                                    clickProductDetailsHandler(product?.slug);
                                  }}
                                >
                                  <a
                                    href=" "
                                    className="product-link1"
                                    style={{ height: "100%" }}
                                  >
                                    <img
                                      src={`${product?.image}`}
                                      alt={product?.name}
                                      className="product-image"
                                      style={{
                                        width: "100%",
                                        maxHeight: "100%",
                                        height: "140px",
                                      }}
                                    />
                                   
                                  </a>
                                </div>
                                <div className="product-info">
                                  <div style={{display:"flex",flexDirection:"column",gap:"5px",justifyContent:"start"}}>
                                    <a
                                    href={product.link}
                                    className=""
                                    style={{
                                      display: "inline-block",
                                      whiteSpace: "nowrap",
                                      overflow: "hidden",
                                      textOverflow: "ellipsis",
                                      maxWidth: "97%",
                                      verticalAlign: "middle",
                                      fontSize: "12px",
                                      textDecoration:"none"
                                    }}
                                  >
                                    <span
                                      onClick={(event) => {
                                        event.preventDefault();
                                        clickProductDetailsHandler(
                                          product?.slug
                                        );
                                      }}
                                    >
                                      {product?.name}
                                    </span>
                                  </a>
                                  <p style={{textAlign:"left",fontSize:'10px',color:"gray",fontWeight:500}}>{product?.name}</p>
                                 </div>
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems:"flex-start",
                                      justifyContent: "flex-start",
                                     gap:"10px"
                                    }}
                                  >
                                    <div
                                      className="product-price"
                                      style={{
                                       fontSize:"14px",
                                        marginTop: "0px",
                                        color: "black",
                                        
                                      }}
                                    >
                                     
                                      <span>${product?.size[0]?.price}/-</span>
                                    </div>
                                    <div
                                      className="product-mrp"
                                      style={{ fontSize: "11px" }}
                                    >
                                      <span className="mrp" style={{color:"#666666ff"}}>
                                        ${product?.size[0]?.mrp}/-
                                      </span>
                                    </div>
                                     <div
                                      className="product-mrp"
                                      style={{ fontSize: "7px" }}
                                    >
                                    <p style={{padding:"6px",backgroundColor:"#fc7f7fff",color:"red",borderRadius:"15px"}}>-{product?.size[0]?.discount_percent}%</p>
                                  </div>
                                  </div>


                                  <a href={product.link}>
                                     <span
                                      onClick={(event) => {
                                        event.preventDefault();
                                        clickProductDetailsHandler(
                                          product?.slug
                                        );
                                      }}
                                    >
                                  <p style={{textAlign:"left",borderBottom:"1px solid black",width:"fit-content",fontSize:"11px",fontWeight:"bold"}}>Shop now</p>
                              </span>
                               </a>

                                </div>
                              </div>
                            </div>
                          );
                        })
                      ) : (
                        <div className="product-grid" style={{ height:"100%"}}>
                          <h3>No Products Found</h3>

                          {window.innerWidth <= 568?
                          <div style={{width:"100%", height:"100%", display:"flex",alignItems:"center", justifyContent:"center"}}>
                          <p style={{textAlign:"center", fontSize:"6vw",fontWeight:"bold"}}>
                          COMMING SOON
                          </p></div>
                          :
                          <div style={{width:"100%", height:"100%", display:"flex",alignItems:"center", justifyContent:"center"}}>
                          <p style={{textAlign:"center", fontSize:"6vw",fontWeight:"bold"}}>
                          COMMING SOON
                          </p></div>}


                        </div>
                      )}
                    </div>
                    : // desktop view
                     <div className="product-grid">
                      {teamProduct && teamProduct.length > 0 ? (
                        teamProduct?.map((product) => {
                          const isFavorite = favorites.some(
                            (item) => item.id === product.id
                          );
                          const discount = product?.size[0]?.discount_percent;
                          console.log("discount : ", discount);
                          return (
                            <div
                              key={product?.id}
                              className="product-card"
                              style={{ position: "relative",minWidth:"280px" }}
                            >
                              <div className="product-box" style={{display:"flex", flexDirection:"column", height:"100%",justifyContent:"space-between"}}>
                                {discount > 0 && (
                                  <div
                                    className="discount-badge pulse-animation"
                                
                                  >
                                    <span style={{ fontSize: "14px" }}>
                                      {discount}% OFF
                                    </span>
                                  </div>
                                )}
                                <span
                                  onClick={() => handleFavorite(product)}
                                  style={{
                                    padding: "5px 10px",
                                    position: "absolute",
                                    top: "10px",
                                    right: "10px",
                                    borderRadius: "20px",
                                    fontSize: "0.9rem",
                                    zIndex: "2",

                                    fontSize: "17px",
                                  }}
                                >
                                  {isFavorite ? (
                                    <FaHeart color="red" />
                                  ) : (
                                    <FaRegHeart color="grey" />
                                  )}
                                </span>
                                <div
                                  className="product-image-wrapper"
                                  style={{minHeight:"70%",height:"70%",width:"270px"}}
                                  onClick={(event) => {
                                    event.preventDefault();
                                    clickProductDetailsHandler(product?.slug);
                                  }}
                                >
                                  <a
                                    href=" "
                                    className="product-link1"
                                    style={{ height: "100%" }}
                                  >
                                    <img
                                      src={`${product?.image}`}
                                      alt={product?.name}
                                      className="product-image"
                                      style={{
                                        width: "270px",
                                        maxHeight: "100%",
                                        height: "400px",
                                      }}
                                    />
                                    <img
                                      src={`${configUrl}${product?.second_image}`}
                                      alt={product?.name}
                                      className="hover-image"
                                      style={{ width: "270px", maxHeight: "100%", height: "400px" }}
                                    />
                                  </a>
                                </div>
                                <div className="product-info">
                                  <a
                                    href={product.link}
                                    className="product-name"
                                    style={{
                                      display: "inline-block",
                                      whiteSpace: "nowrap",
                                      overflow: "hidden",
                                      textOverflow: "ellipsis",
                                      maxWidth: "97%",
                                      verticalAlign: "middle",
                                      fontSize: "18px",
                                    }}
                                  >
                                    <span
                                      onClick={(event) => {
                                        event.preventDefault();
                                        clickProductDetailsHandler(
                                          product?.slug
                                        );
                                      }}
                                    >
                                      {product?.name}
                                    </span>
                                  </a>
                                  <p style={{textAlign:"left",fontSize:'14px',color:"gray",fontWeight:500}}>{product?.name}</p>
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems:"flex-start",
                                      justifyContent: "flex-start",
                                     gap:"10px"
                                    }}
                                  >
                                    <div
                                      className="product-price"
                                      style={{
                                       fontSize:"16px",
                                        marginTop: "0px",
                                        color: "black",
                                        
                                      }}
                                    >
                                     
                                      <span>${product?.size[0]?.price}/-</span>
                                    </div>
                                    <div
                                      className="product-mrp"
                                      style={{ fontSize: "12px" }}
                                    >
                                      <span className="mrp" style={{color:"#666666ff"}}>
                                        ${product?.size[0]?.mrp}/-
                                      </span>
                                    </div>
                                     <div
                                      className="product-mrp"
                                      style={{ fontSize: "9px" }}
                                    >
                                    <p style={{padding:"6px",backgroundColor:"#fc7f7fff",color:"red",borderRadius:"15px"}}>-{product?.size[0]?.discount_percent}%</p>
                                  </div>
                                  </div>
                                  <a href={product.link}>
                                     <span
                                      onClick={(event) => {
                                        event.preventDefault();
                                        clickProductDetailsHandler(
                                          product?.slug
                                        );
                                      }}
                                    >
                                  <p style={{textAlign:"left",borderBottom:"1px solid black",width:"fit-content",fontSize:"15px",fontWeight:"bold"}}>Shop now</p>
                               </span></a>
                                </div>
                              </div>
                            </div>
                          );
                        })
                      ) : (
                        <div className="product-grid" style={{ height:"100%"}}>
                          <h3>No Products Found</h3>

                          {window.innerWidth <= 568?
                          <div style={{width:"100%", height:"100%", display:"flex",alignItems:"center", justifyContent:"center"}}>
                          <p style={{textAlign:"center", fontSize:"6vw",fontWeight:"bold"}}>
                          COMMING SOON
                          </p></div>
                          :
                          <div style={{width:"100%", height:"100%", display:"flex",alignItems:"center", justifyContent:"center"}}>
                          <p style={{textAlign:"center", fontSize:"6vw",fontWeight:"bold"}}>
                          COMMING SOON
                          </p></div>}


                        </div>
                      )}
                    </div>}
                  </div>

                 
                </section>
                }
                 {!isFiltered?
                 <div style={{display:"flex", alignItems:"center", justifyContent:"center", marginTop:"20px"}}>
                    {pagination.map((page)=>(
                      <p onClick={()=>{
                       handleGetTeamProducts(page)
                        setCurrentPage(page)
                      }}
                      style={{padding:"14px",cursor:"pointer",fontSize:"15px",border:"0.5px solid gray",borderRadius:"8px",margin:"10px",backgroundColor:currentPage===page?"gray":"white"}}>
                        {page}</p>
                    ))}
                  </div>:""}
                </div>
                
              </div>
            </div>
          </div>
        </main>
        <Design />
       
        <Footer />
      </body>
    </div>
  );
}

export default TeamOrder;
